import React, { useState } from 'react';
import * as LucideIcons from 'lucide-react';
import apiClient, { endpoints } from '../../api';
import './ForgotPassword.css';

const ForgotPassword = ({ onBackToLogin }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Email is required');
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await apiClient.post(endpoints.forgotPassword, {
        email: email
      });

      if (response.status === 200) {
        setMessage('If this email is registered, a password reset link has been sent.');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      
      if (error.response) {
        setError(error.response.data.error || 'Failed to send reset link. Please try again.');
      } else if (error.request) {
        setError('No response from server. Please check if backend is running.');
      } else {
        setError('Failed to send reset link. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackToLogin = () => {
    onBackToLogin();
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <div className="forgot-password-header">
          <div className="forgot-password-logo">
            <h1>SonicKart</h1>
            <p style={{color:"#ffc727"}}>From your store to every doorstep with SonicKart</p>
            <h2 style={{color:"#ffffff"}}>Reset Your Password</h2>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="forgot-password-form">
          {error && (
            <div className="error-message general">
              <LucideIcons.AlertCircle size={16} />
              <span>{error}</span>
            </div>
          )}

          {message && (
            <div className="success-message general">
              <LucideIcons.CheckCircle size={16} />
              <span>{message}</span>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email Address
            </label>
            <div className="input-container">
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder="Enter your registered email"
                disabled={isLoading}
                required
              />
            </div>
          </div>

          <button
            type="submit"
            className={`forgot-password-btn ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <div className="spinner"></div>
                Sending Reset Link...
              </>
            ) : (
              'Send Reset Link'
            )}
          </button>
        </form>

        <div className="forgot-password-footer">
          <p>
            Remember your password? 
            <button 
              type="button" 
              className="switch-link"
              onClick={handleBackToLogin}
            >
              Back to Login
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
